import { forwardRef } from 'react';

import CloseIcon from '@/components/icons/close';
import SearchIcon from '@/components/icons/search';
import { Input } from '@/components/ui/input';

interface SearchBarProps {
  ref?: React.Ref<HTMLInputElement>;
  search: string;
  setSearch: (search: string) => void;
  className?: string;
  containerClassName?: string;
  placeholder?: string;
  'aria-label'?: string;
}

const SearchBar = forwardRef<HTMLInputElement, SearchBarProps>(
  ({ search, setSearch, className, containerClassName, placeholder = 'Search...', 'aria-label': ariaLabel }, ref) => {
    return (
      <Input
        ref={ref}
        className={className}
        containerClassName={containerClassName}
        prefix={<SearchIcon />}
        placeholder={placeholder}
        aria-label={ariaLabel}
        value={search}
        onChange={(e) => setSearch(e.target.value)}
        suffix={
          search && (
            <button type="button" className="bg-grey-5 mr-1 rounded-full text-white" onClick={() => setSearch('')} aria-label="Clear search">
              <CloseIcon size={15} />
            </button>
          )
        }
      />
    );
  },
);

export default SearchBar;
